import { useTranslation } from "react-i18next";
import { languages } from "../i18n";
import "../styles/main.scss";

interface HeaderProps {
  // Simplified props - most functionality moved elsewhere
  usernameText?: string;
  usernameNumber?: string;
  nameHint?: string | null;
  onUsernameChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  showAuthGate?: boolean;
  isAuthenticated?: boolean;
  showInstallBtn?: boolean;
  showHelpBtn?: boolean;
  onPromptInstall?: () => void;
  onShowInstallHelp?: () => void;
  hasJoinedRoom?: boolean;
}

/**
 * Header Component - Figma Design
 * Simple centered "BlinkBli" title with language switcher
 */
export function Header(_props: HeaderProps) {
  const { i18n } = useTranslation();

  return (
    <header className="header">
      <select 
        className="header__lang-switcher"
        value={i18n.language} 
        onChange={(e) => i18n.changeLanguage(e.target.value)}
      >
        {languages.map(lang => (
          <option key={lang.code} value={lang.code}>
            {lang.name}
          </option>
        ))}
      </select>
      <strong className="header__title">BlinkBli</strong>
      <div className="header__spacer" />
    </header>
  );
}

/**
 * Chat Header Component - For chat room view
 * Has back button and members toggle
 */
interface ChatHeaderProps {
  onBack: () => void;
  onToggleMembers: () => void;
  showMembersBtn?: boolean;
}

export function ChatHeader({ onBack, onToggleMembers, showMembersBtn = true }: ChatHeaderProps) {
  return (
    <header className="chat-header">
      <button onClick={onBack} className="chat-header__back">
        ← Back
      </button>
      <strong className="chat-header__title">BlinkBli</strong>
      {showMembersBtn && (
        <button onClick={onToggleMembers} className="chat-header__members">
          👥
        </button>
      )}
    </header>
  );
}
